<!-- <header class="header" role="banner" style="display: none">
  <h1 class="ofchart_title">MyGoldBank - Grafico del prezzo dell'oro</h1>
  <h2 class="ofchart_subtitle">Seleziona sul grafico la parte che vuoi ingrandire</h2>
</header> -->

<ion-grid style="padding: 0px;">
  <ion-row>
      <ion-col>
        <section
  id="ofchart_controls"
  role="region"
  aria-label="Controlli del grafico"
  class="chart-controls-section"
>
  <div class="controls-container">
    <div class="controls-panel timeframe-panel">
      <div id="ofchart_timeframe" role="group" aria-label="Selezione intervallo temporale">
        <ng-container *ngFor="let tf of timeframes">
          <button
            [id]="'ofchart_' + tf.id"
            class="ofchart_button"
            [class.selected]="interval === tf.id"
            [attr.aria-pressed]="interval === tf.id"
            [attr.aria-label]="tf.title"
            [title]="tf.title"
            (click)="onTimeframeSelect(tf.id)"
          >
            {{ tf.label }}
          </button>
        </ng-container>
      </div>
    </div>

    <div class="controls-panel settings-panel">
      <div class="settings-group" style="width: 100%;">
        <label for="ofchart_currency" class="settings-label">Valuta:</label>
        <select
          class="ofchart_list"
          id="ofchart_currency"
          [(ngModel)]="currency"
          (change)="onCurrencyChange()"
          aria-label="Seleziona valuta"
        >
          <option value="EUR">EUR</option>
          <option value="USD">USD</option>
          <option value="GBP">GBP</option>
          <option value="JPY">JPY</option>
          <option value="AUD">AUD</option>
          <option value="CAD">CAD</option>
          <option value="CHF">CHF</option>
        </select>
        <div style="display: flex; justify-content: flex-end; width: 100%;">
          <img src="./assets/icon/MyGoldLogo.png" alt="Logo MyGold Bank" style="max-height: 50px;   opacity: 0.3;">
        </div>
        

      </div>

      <!-- <div class="settings-group">
        <label for="ofchart_type" class="settings-label">Tipo:</label>
        <select
          class="ofchart_list"
          id="ofchart_type"
          [(ngModel)]="chartType"
          (change)="onChartTypeChange()"
          aria-label="Seleziona tipo di grafico"
        >
          <option value="area">Area</option>
          <option value="line">Linea</option>
        </select>
      </div> -->
    </div>

    <!-- <div class="controls-panel price-panel">
      <div class="live-prices" role="status" aria-live="polite">
        <div class="price-display">
          
          <span class="gold-price" [attr.data-value]="goldPrice">{{ goldPrice || '....' }}</span>
          <span class="kg-euros">&nbsp;{{ currency }}/Kg</span>
          <span class="live-indicator" *ngIf="isLiveUpdateEnabled">
            <span class="visually-hidden">Aggiornamenti in tempo reale attivi</span>
            Live
          </span>
          <button
            *ngIf="isIntraday"
            class="live-toggle-btn"
            [class.active]="isLiveUpdateEnabled"
            (click)="toggleLiveUpdates()"
            [attr.aria-label]="
              isLiveUpdateEnabled
                ? 'Ferma aggiornamenti in tempo reale'
                : 'Avvia aggiornamenti in tempo reale'
            "
            [attr.aria-pressed]="isLiveUpdateEnabled"
            [title]="
              isLiveUpdateEnabled
                ? 'Ferma aggiornamenti in tempo reale'
                : 'Avvia aggiornamenti in tempo reale'
            "
          >
            <svg
              *ngIf="!isLiveUpdateEnabled"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              
              <polygon
                points="5,3 19,12 5,21"
                stroke-width="1.5"
                fill="rgba(173,153,101,0.2)"
              ></polygon>
            </svg>
            <svg
              *ngIf="isLiveUpdateEnabled"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              
              <rect
                x="5"
                y="5"
                width="14"
                height="14"
                stroke-width="1.5"
                fill="rgba(173,153,101,0.2)"
              ></rect>
            </svg>
          </button>
        </div>

        <div id="last-updated-prices-div">
          Ultimo aggiornamento
          <time id="last-updated-prices-span">{{ lastUpdated || '.....' }}</time>
        </div>
      </div>
    </div> -->
  </div>
</section>

<main id="container" role="main"  style="height: 100%;">
  <highcharts-chart
    [Highcharts]="Highcharts"
    [constructorType]="'stockChart'"
    [options]="chartOptions"
    [callbackFunction]="chartCallback"
    style="width: 100%; height: 35vh; display: block"
    aria-label="Grafico dell'andamento del prezzo dell'oro"
  ></highcharts-chart>
</main>

      </ion-col>
    </ion-row>
</ion-grid>

